




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'text-field' })
export default class TextFieldComponent extends Vue {
  @Prop() public value!: string;
  @Prop() public name!: string;
  @Prop({ type: Boolean, default: false }) public password!: boolean;

  public get innerValue() { return this.value; }
  public set innerValue(val: string) {
    this.$emit('input', val);
  }
}
